module.exports = __webpack_public_path__ + "img/4.570d54e3.jpg";